import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["tablet", "phone", "phoneWide"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import units from "units-css";
var identity = function (x) {
  return x;
};
export var breakpointExtensions = {
  phone: function (props) {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), props.tablet), props.phoneWide), props.phone);
  },
  phoneWide: function (props) {
    return _objectSpread(_objectSpread(_objectSpread({}, props), props.tablet), props.phoneWide);
  },
  tablet: function (props) {
    return _objectSpread(_objectSpread({}, props), props.tablet);
  },
  desktop: identity
};
export var extendWithBreakpointValues = function (props, breakpoint) {
  var _ref,
    breakpointProps = (breakpointExtensions[breakpoint] || identity)(props);
  return (_ref = breakpointProps).tablet, _ref.phone, _ref.phoneWide, _objectWithoutProperties(_ref, _excluded);
};
export var getBreakpointPxValue = function (device, rootElement) {
  var element = function (rootElement) {
      var _document,
        _root$querySelector,
        root = rootElement || (null === (_document = document) || void 0 === _document ? void 0 : _document.body);
      return null !== (_root$querySelector = root.querySelector(".themeRoot")) && void 0 !== _root$querySelector ? _root$querySelector : root;
    }(rootElement),
    breakpointValue = "function" == typeof getComputedStyle && getComputedStyle(element).getPropertyValue("--GW-BREAKPOINT-".concat(device.toUpperCase()));
  return breakpointValue && units.convert("px", breakpointValue, element);
};
export var getBreakpoints = function (rootElement) {
  return {
    phone: getBreakpointPxValue("phone", rootElement) || 580,
    phoneWide: getBreakpointPxValue("phoneWide", rootElement) || 768,
    tablet: getBreakpointPxValue("tablet", rootElement) || 1024
  };
};
export var breakpoints = ["phone", "phoneWide", "tablet"];